import { CaretRightIcon } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export interface IBreadcrumbItem {
  name: string;
  to: string;
}

export interface IBreadcrumbProps {
  parentItem?: IBreadcrumbItem | null;
  currentItem: string;
  /** Optional counter / status line under the title, e.g. "2 van 7 ladingen gepland". */
  meta?: React.ReactNode;
}

/**
 * Page title, with an optional parent link above it and an optional meta line
 * below it. Every page header title goes through this component — it is the
 * only place `.page-title` is applied.
 */
export const Breadcrumb: React.FC<IBreadcrumbProps> = (props) => {
  const { parentItem, currentItem, meta } = props;

  return (
    <div className="flex min-w-0 flex-col justify-center gap-[3px]">
      {parentItem && (
        <Link
          to={parentItem.to}
          className="page-crumb inline-flex items-center gap-[5px] transition-colors hover:text-fg-secondary"
        >
          {parentItem.name}
          <CaretRightIcon className="h-2.5 w-2.5" weight="bold" />
        </Link>
      )}

      <h1 className="page-title truncate">{currentItem}</h1>

      {meta != null && <span className="caption-text truncate">{meta}</span>}
    </div>
  );
};
